/*
  Collection of custom validation rules for listing form
*/

import { required, requiredIfFieldIs, requiredIfFieldContains, dateNotLessThan, dateNotLessThanToday} from '../../helpr/generic-validation-rules';

export const securityTypeAndFormObj= (obj) => {
  return {
    fields: {
      securityType: {
        value: obj.securityType,
        style: {}
      },
      securityForm: {
        value: obj.securityForm,
        style: {}
      },
      securityClass: {
        value: obj.securityClass,
        style: {}
      },
      mannerOfDistrib: {
        value: obj.mannerOfDistrib,
        style: {}
      },
      numberOfSecurity: {
        value: obj.numberOfSecurity,
        style: {}
      }
    },
    dynamicFields: {}
  }
}

export const securityInfoObj = (obj) => {
  return {
    fields: {
      id: {
        value: obj.id,
        style: {}
      },
      longName: {
        value: obj.longName,
        style: {}
      },
      prefShortName: {
        value: obj.prefShortName,
        style: {}
      },
      countryOfIssue: {
        value: obj.countryOfIssue,
        style: {}
      },
      currency: {
        value: obj.currency,
        style: {}
      },
      listingDate: {
        value: obj.listingDate,
        style: {}
      },
      maturityDate: {
        value: obj.maturityDate,
        style: {}
      },
      amount: {
        value: obj.amount.toString(),
        style: {}
      },
      amountOutstanding: {
        value: obj.amountOutstanding.toString(),
        style: {}
      },
      tenor: {
        value: obj.tenor,
        style: {}
      },
      issuePrice: {
        value: obj.issuePrice,
        style: {}
      },
      redemptionPrice: {
        value: obj.redemptionPrice,
        style: {}
      },
      couponType: {
        value: obj.couponType,
        style: {}
      },
      couponDiscountRate: {
        value: obj.couponDiscountRate,
        style: {}
      },
      couponFixedInterestRate: {
        value: obj.couponFixedInterestRate,
        style: {}
      },
      couponFixedRateSettingDate: {
        value: obj.couponFixedRateSettingDate,
        style: {}
      },
      couponFixedRefRateUsed : {
        value: obj.couponFixedRefRateUsed,
        style: {}
      },
      couponFixedSpreadOverRefRate: {
        value: obj.couponFixedSpreadOverRefRate,
        style: {}
      },
      couponFloatingRateBasis: {
        value: obj.couponFloatingRateBasis,
        style: {}
      },
      couponSteppedProvisionDesc: {
        value: obj.couponSteppedProvisionDesc,
        style: {}
      },
      couponFrequency: {
        value: obj.couponFrequency,
        style: {}
      },
      couponPaymentDate: {
        value: obj.couponPaymentDate,
        style: {}
      },
      couponFirstPaymentDate: {
        value: obj.couponFirstPaymentDate,
        style: {}
      },
      couponRecordDate: {
        value: obj.couponRecordDate,
        style: {}
      },
      couponClosedPeriod: {
        value: obj.couponClosedPeriod,
        style: {}
      },
      primaryMarketMinDenomination: {
        value: obj.denomination.primary.minimum.toString(),
        style: {}
      },
      primaryMarketMinIncrements: {
        value: obj.denomination.primary.increments.toString(),
        style: {}
      },
      secondaryMarketMinDenomination: {
        value: obj.denomination.secondary.minimum.toString(),
        style: {}
      },
      secondaryMarketMinIncrements: {
        value: obj.denomination.secondary.increments.toString(),
        style: {}
      },
      offerPeriodFrom: {
        value: obj.offerPeriodFrom,
        style: {}
      },
      offerPeriodTo: {
        value: obj.offerPeriodTo,
        style: {}
      }
    },
    dynamicFields: {
      redemptionDetail: obj.redemptionDetail
    }
  }
}

export const multiSecurityInfoObj = (obj) => {
  return {
    fields: {
      id: {
        value: obj.id,
        style: {}
      },
      longName: {
        value: obj.longName,
        style: {}
      },
      prefShortName: {
        value: obj.prefShortName,
        style: {}
      },
      countryOfIssue: {
        value: obj.countryOfIssue,
        style: {}
      },
      currency: {
        value: obj.currency,
        style: {}
      },
      listingDate: {
        value: obj.listingDate,
        style: {}
      },
      maturityDate: {
        value: obj.maturityDate,
        style: {}
      },
      amount: {
        value: obj.amount.toString(),
        style: {}
      },
      amountOutstanding: {
        value: obj.amountOutstanding.toString(),
        style: {}
      },
      tenor: {
        value: obj.tenor,
        style: {}
      },
      issuePrice: {
        value: obj.issuePrice,
        style: {}
      },
      redemptionPrice: {
        value: obj.redemptionPrice,
        style: {}
      },
      couponType: {
        value: obj.couponType,
        style: {}
      },
      couponDiscountRate: {
        value: obj.couponDiscountRate,
        style: {}
      },
      couponFixedInterestRate: {
        value: obj.couponFixedInterestRate,
        style: {}
      },
      couponFixedRateSettingDate: {
        value: obj.couponFixedRateSettingDate,
        style: {}
      },
      couponFixedRefRateUsed : {
        value: obj.couponFixedRefRateUsed,
        style: {}
      },
      couponFixedSpreadOverRefRate: {
        value: obj.couponFixedSpreadOverRefRate,
        style: {}
      },
      couponFloatingRateBasis: {
        value: obj.couponFloatingRateBasis,
        style: {}
      },
      couponSteppedProvisionDesc: {
        value: obj.couponSteppedProvisionDesc,
        style: {}
      },
      couponFrequency: {
        value: obj.couponFrequency,
        style: {}
      },
      couponPaymentDate: {
        value: obj.couponPaymentDate,
        style: {}
      },
      couponFirstPaymentDate: {
        value: obj.couponFirstPaymentDate,
        style: {}
      },
      couponRecordDate: {
        value: obj.couponRecordDate,
        style: {}
      },
      couponClosedPeriod: {
        value: obj.couponClosedPeriod,
        style: {}
      },
      primaryMarketMinDenomination: {
        value: obj.denomination.primary.minimum.toString(),
        style: {}
      },
      primaryMarketMinIncrements: {
        value: obj.denomination.primary.increments.toString(),
        style: {}
      },
      secondaryMarketMinDenomination: {
        value: obj.denomination.secondary.minimum.toString(),
        style: {}
      },
      secondaryMarketMinIncrements: {
        value: obj.denomination.secondary.increments.toString(),
        style: {}
      }
    },
    dynamicFields: {
      redemptionDetail: obj.redemptionDetail
    }
  }
}

export const offerPeriodObj = (obj) => {
  return {
    fields: {
      offerPeriodFrom: {
        value: obj.offerPeriodFrom,
        style: {}
      },
      offerPeriodTo: {
        value: obj.offerPeriodTo,
        style: {}
      }
    },
    dynamicFields: {}
  }
}

export const securityInfoObj2 = (obj) => {
  return {
    fields: {
      securityType: { 
        value: obj.securityType,
        style: {}
      },
      yearBasis: {
        value: obj.yearBasis,
        style: {}
      },
      wtpeiRemittanceConvention: {
        value: obj.wtpeiRemittanceConvention,
        style: {}
      },
      dayCountConvention: {
        value: obj.dayCountConvention,
        style: {}
      },
      principalRepaymentSched: {
        value: obj.principalRepaymentSched,
        style: {}
      },
      amortizationSched: {
        value: obj.amortizationSched,
        style: {}
      }
    },
    dynamicFields: {}
  }
}

export const securityInfoObj3 = (obj) => {
  return {
    fields: {
      preterminationProvisionDescription: {
        value: obj.preterminationProvisionDescription,
        style: {}
      },
      transferOfSecurityRestrictions: {
        value: obj.transferOfSecurityRestrictions,
        style: {}
      },
      ownershipType: {
        value: obj.ownershipLimit.type,
        style: {}
      },
      ownershipPercentage: {
        value: obj.ownershipLimit.percentage,
        style: {}
      },
      taxApplicable: {
        value: obj.tax.applicable.toString(),
        style: {}
      },
      taxPercentage: {
        value: obj.tax.percentage,
        style: {}
      }
    },
    dynamicFields: {}
  }
}


export const securityTypeAndFormValidator = {
  fields: {
    securityType: [required],
    securityForm: [required],
    securityClass: [required],
    mannerOfDistrib: [required],
    numberOfSecurity: [required]
  },
  dynamicFields: {}
}

export const securityInfoValidator = {
  fields: {
    id: [],
    longName: [required],
    prefShortName: [required],
    countryOfIssue: [required],
    currency: [required],
    listingDate: [
      required,
      dateNotLessThanToday
    ],
    maturityDate: [
      required,
      v => dateNotLessThan(v, 'listingDate')
    ],
    amount: [required],
    amountOutstanding: [],
    tenor: [required],
    issuePrice: [required],
    redemptionPrice: [required],
    offerPeriodFrom: [
      required,
      dateNotLessThanToday
    ],
    offerPeriodTo: [
      required,
      v => dateNotLessThan(v, 'offerPeriodFrom')
    ],
    couponType: [required],
    couponDiscountRate: [
      v => requiredIfFieldIs(v, 'couponType', 'DISCOUNT')
    ],
    couponFixedInterestRate: [
      v => requiredIfFieldIs(v, 'couponType', 'FIXED')
    ],
    couponFixedRateSettingDate: [
      v => requiredIfFieldIs(v, 'couponType', 'FIXED')
    ],
    couponFixedRefRateUsed: [
      v => requiredIfFieldIs(v, 'couponType', 'FIXED')
    ],
    couponFixedSpreadOverRefRate: [
      v => requiredIfFieldIs(v, 'couponType', 'FIXED')
    ],
    couponFloatingRateBasis: [
      v => requiredIfFieldIs(v, 'couponType', 'FLOATING')
    ],
    couponSteppedProvisionDesc: [],
    couponFrequency: [ required ],
    couponPaymentDate: [
      v => requiredIfFieldContains(v, 'couponFrequency', ['MONTHLY','ANNUAL','SEMI-ANNUAL','QUARTERLY'])
    ],
    couponFirstPaymentDate: [
      v => requiredIfFieldContains(v, 'couponFrequency', ['MONTHLY','ANNUAL','SEMI-ANNUAL','QUARTERLY'])
    ],
    couponRecordDate: [
      v => requiredIfFieldContains(v, 'couponFrequency', ['MONTHLY','ANNUAL','SEMI-ANNUAL','QUARTERLY'])
    ],
    couponClosedPeriod: [
      v => requiredIfFieldContains(v, 'couponFrequency', ['MONTHLY','ANNUAL','SEMI-ANNUAL','QUARTERLY'])
    ],
    primaryMarketMinDenomination: [ required ],
    primaryMarketMinIncrements: [ required ],
    secondaryMarketMinDenomination: [ required ],
    secondaryMarketMinIncrements: [ required ]
  },
  dynamicFields: {
    redemptionDetail: {
      optional_redemption_date: [
        dateNotLessThanToday
      ],
      optional_redemption_price: []
    }
  }
}

export const securityInfoValidatorPublished = {
  ...securityInfoValidator,
  fields: {
    ...securityInfoValidator.fields,
    offerPeriodFrom: [ required ],
    listingDate: [ required ]
  },
  dynamicFields: {
    redemptionDetail: {
      optional_redemption_date: [],
      optional_redemption_price: []
    }
  }
}


export const multiSecurityInfoValidator = {
  fields: {
    id: [],
    longName: [required],
    prefShortName: [required],
    countryOfIssue: [required],
    currency: [required],
    listingDate: [
      dateNotLessThanToday,
      required
    ],
    maturityDate: [required],
    amount: [required],
    amountOutstanding: [],
    tenor: [required],
    issuePrice: [required],
    redemptionPrice: [required],
    couponType: [required],
    couponDiscountRate: [
      v => requiredIfFieldIs(v, 'couponType', 'DISCOUNT')
    ],
    couponFixedInterestRate: [
      v => requiredIfFieldIs(v, 'couponType', 'FIXED')
    ],
    couponFixedRateSettingDate: [
      v => requiredIfFieldIs(v, 'couponType', 'FIXED')
    ],
    couponFixedRefRateUsed: [
      v => requiredIfFieldIs(v, 'couponType', 'FIXED')
    ],
    couponFixedSpreadOverRefRate: [
      v => requiredIfFieldIs(v, 'couponType', 'FIXED')
    ],
    couponFloatingRateBasis: [
      v => requiredIfFieldIs(v, 'couponType', 'FLOATING')
    ],
    couponSteppedProvisionDesc: [],
    couponFrequency: [ required ],
    couponPaymentDate: [
      v => requiredIfFieldContains(v, 'couponFrequency', ['MONTHLY','ANNUAL','SEMI-ANNUAL','QUARTERLY'])
    ],
    couponFirstPaymentDate: [
      v => requiredIfFieldContains(v, 'couponFrequency', ['MONTHLY','ANNUAL','SEMI-ANNUAL','QUARTERLY'])
    ],
    couponRecordDate: [
      v => requiredIfFieldContains(v, 'couponFrequency', ['MONTHLY','ANNUAL','SEMI-ANNUAL','QUARTERLY'])
    ],
    couponClosedPeriod: [
      v => requiredIfFieldContains(v, 'couponFrequency', ['MONTHLY','ANNUAL','SEMI-ANNUAL','QUARTERLY'])
    ],
    primaryMarketMinDenomination: [ required ],
    primaryMarketMinIncrements: [ required ],
    secondaryMarketMinDenomination: [ required ],
    secondaryMarketMinIncrements: [ required ]
  },
  dynamicFields: {
    redemptionDetail: {
      optional_redemption_date: [
        dateNotLessThanToday
      ],
      optional_redemption_price: []
    }
  }
}

export const multiSecurityInfoValidatorPublished = {
  ...multiSecurityInfoValidator,
  fields: {
    ...multiSecurityInfoValidator.fields,
    listingDate: [ required ]
  },
  dynamicFields: {
    redemptionDetail: {
      optional_redemption_date: [],
      optional_redemption_price: []
    }
  }
}

export const offerPeriodValidator = {
  fields: {
    offerPeriodFrom: [ 
      required,
      dateNotLessThanToday
    ],
    offerPeriodTo: [ 
      required,
      v => dateNotLessThan(v, 'offerPeriodFrom')
    ]
  },
  dynamicFields: {}
}

export const offerPeriodValidatorPublished = {
  ...offerPeriodValidator,
  fields: {
    ...offerPeriodValidator.fields,
    offerPeriodFrom: [ required ]
  }
}

export const securityInfoValidator2 = {
  fields: {
    securityType: [],
    yearBasis: [ required ],
    wtpeiRemittanceConvention: [],
    dayCountConvention: [ required ],
    principalRepaymentSched: [ required ],
    amortizationSched: [
      v => requiredIfFieldIs(v, 'principalRepaymentSched', 'AMORTIZED')
    ]
  },
  dynamicFields: {}
}

export const securityInfoValidator3 = {
  fields: {
    preterminationProvisionDescription: [],
    transferOfSecurityRestrictions: [ required ],
    ownershipType: [ required ],
    ownershipPercentage: [
      v => requiredIfFieldContains(v, 'ownershipType', ['FIL','FOREIGN'])
    ],
    taxApplicable: [ required ],
    taxPercentage: [
      v => requiredIfFieldIs(v, 'taxApplicable', 'true')
    ]
  },
  dynamicFields: {}
}

